export enum MediaType {
  "Image" = 0,
  "Video" = 1,
  "Text" = 2,
  "YouTube" = 3
}
